import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import resourcesToBackend from 'i18next-resources-to-backend';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(resourcesToBackend((language, namespace) => import(`../language/${language}/LC_MESSAGES/messages.json`)))
  .init({
    lng: ENV.lang, // if you're using a language detector, do not define the lng option
    fallbackLng: "en_GB",

    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
});

export default i18n;